import React from 'react';
import './index.scss';
import InteractionButton from '../InteractionButton';
import useClaimDistributor from '../../hooks/useClaimDistributor';
import { formatAmount } from '../../utils/format';
import useGenericCall from '../../hooks/useGenericCall';
import { useOnchainAccount } from '../../hooks/useOnchain';
import { DistributorDetails } from 'impermax-sdk';


export default function ClaimDistributor({ distributor }: { distributor: DistributorDetails }) {
  const availableClaimable = useGenericCall(
    useOnchainAccount(), 
    onchainAccount => onchainAccount.getClaimableIBEX(distributor.claimableAddress)
  );
  const [claimDistributorState, onClaimDistributor] = useClaimDistributor(distributor);

  if (!availableClaimable) return (null);

  return (
    <div className="claim-distributor">
      <div><b>{ distributor.name }</b></div>
      <div>
        <InteractionButton name={"Claim " + formatAmount(availableClaimable) + " IBEX"} onCall={onClaimDistributor} state={claimDistributorState} />
      </div>
    </div>
  );
}